const React = require('react');
const { createElement: h } = React;
require('./LiveModeBanner.css');

// A slim banner pinned to the top of the canvas while the Staging/Live toggle is
// on "Live". It signals that the canvas below is the read-only published version
// and offers an "Update" action (republish staging → live). The canvas itself
// renders the live snapshot read-only; this is purely the status + action strip.
//
//   version:  string | null — current published version
//   hasLive:  boolean — a live snapshot exists (vs nothing published yet)
//   loading:  boolean — snapshot is being fetched
//   dirty:    boolean — unsaved config (variable value / account pin) edits in Live
//   saving:   boolean — a live config save is in flight
//   onSave:   () => void — persist config edits to the live snapshot
//   onUpdate: () => void — open the publish/update dialog (republish from staging)
//   offline:  boolean — live is switched off; runs use staging instead
//   offlineBusy: boolean — the online/offline switch is saving
//   onToggleOffline: () => void — flip live online ↔ offline
function LiveModeBanner(props) {
  var version = props.version || null;
  var hasLive = !!props.hasLive;
  var loading = !!props.loading;
  var dirty = !!props.dirty;
  var saving = !!props.saving;
  var onSave = typeof props.onSave === 'function' ? props.onSave : function() {};
  var onUpdate = typeof props.onUpdate === 'function' ? props.onUpdate : function() {};
  var offline = !!props.offline;
  var offlineBusy = !!props.offlineBusy;
  var onToggleOffline = typeof props.onToggleOffline === 'function' ? props.onToggleOffline : function() {};

  var text;
  if (loading) {
    text = 'Loading live version…';
  } else if (hasLive && offline) {
    text = 'Live version' + (version ? ' v' + version : '') + ' is offline · runs use staging';
  } else if (hasLive) {
    text = version
      ? ('Live version v' + version + ' · variables & accounts editable')
      : 'Live version · variables & accounts editable';
  } else {
    text = 'No live version published yet';
  }

  return h('div', { className: 'live-banner' },
    h('span', { className: 'live-banner-badge' + (hasLive && offline ? ' is-offline' : '') }, hasLive && offline ? 'OFFLINE' : 'LIVE'),
    h('span', { className: 'live-banner-text' }, text),
    // Save config edits — only relevant once something is published.
    hasLive
      ? h('button', {
          className: 'live-banner-save-btn',
          onClick: onSave,
          disabled: saving || !dirty,
          title: dirty ? 'Save variable value & account edits to the live version' : 'No unsaved changes'
        }, saving ? 'Saving…' : (dirty ? 'Save changes' : 'Saved'))
      : null,
    // Online/offline switch — offline keeps the live snapshot but serves staging.
    hasLive
      ? h('button', {
          className: 'live-banner-toggle' + (offline ? '' : ' is-on'),
          role: 'switch',
          'aria-checked': !offline,
          onClick: onToggleOffline,
          disabled: offlineBusy,
          title: offline ? 'Put the live version back online' : 'Take the live version offline (runs will use staging)'
        },
          h('span', { className: 'live-banner-toggle-track' }, h('span', { className: 'live-banner-toggle-knob' })),
          offline ? 'Offline' : 'Online'
        )
      : null,
    h('button', {
      className: 'live-banner-update-btn',
      onClick: onUpdate,
      title: hasLive
        ? 'Update the live version from staging (new version)'
        : 'Publish staging as the live version'
    }, hasLive ? 'Update from staging' : 'Publish')
  );
}

module.exports = LiveModeBanner;
